export const Memberships_Action_Types = {
    FETCH_MEMBERSHIPS_START: "memberships/FETCH_MEMBERSHIPS_START",
    FETCH_MEMBERSHIPS_SUCCESS: "memberships/FETCH_MEMBERSHIPS_SUCCESS",
    FETCH_MEMBERSHIPS_LIST_BY_TYPE: "memberships/FETCH_MEMBERSHIPS_LIST_BY_TYPE",
    FETCH_MEMBERSHIPS_FAILED: "memberships/FETCH_MEMBERSHIPS_FAILED",
    SET_PAGE_SIZE: "memberships/SET_PAGE_SIZE",
    SET_IS_UPDATED: "memberships/SET_IS_UPDATED",
    SET_PAGE_NUMBER: "memberships/SET_PAGE_NUMBER",
    SET_FILTER_SEARCH_STRING: "memberships/SET_FILTER_SEARCH_STRING",
    }